import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class ExcelOrderImport_ds_get_lots_by_materials_projects_lotsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { lotLookupcodes?: string[], materialLookupcodes?: string[], projectLookupcodes?: string[], vendorLotLookupcodes?: string[], fullTextSearch?: string, materialId?: number, vendorLotId?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, VendorLotId?: number, Material?: { Id?: number, LookupCode?: string, Project?: { Id?: number, LookupCode?: string } }, VendorLot?: { Id?: number, LookupCode?: string } }[] }> 
  {
    let url = `${environment.backendUrl}api/ExcelOrderImport/datasources/ds_get_lots_by_materials_projects_lots/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { lotLookupcodes?: string[], materialLookupcodes?: string[], projectLookupcodes?: string[], vendorLotLookupcodes?: string[], fullTextSearch?: string, materialId?: number, vendorLotId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, VendorLotId?: number, Material?: { Id?: number, LookupCode?: string, Project?: { Id?: number, LookupCode?: string } }, VendorLot?: { Id?: number, LookupCode?: string } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/ExcelOrderImport/datasources/ds_get_lots_by_materials_projects_lots/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { lotLookupcodes?: string[], materialLookupcodes?: string[], projectLookupcodes?: string[], vendorLotLookupcodes?: string[], fullTextSearch?: string, materialId?: number, vendorLotId?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, VendorLotId?: number, Material?: { Id?: number, LookupCode?: string, Project?: { Id?: number, LookupCode?: string } }, VendorLot?: { Id?: number, LookupCode?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/ExcelOrderImport/datasources/ds_get_lots_by_materials_projects_lots/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      lotLookupcodes?: string[], materialLookupcodes?: string[], projectLookupcodes?: string[], vendorLotLookupcodes?: string[], fullTextSearch?: string, materialId?: number, vendorLotId?: number    }) {
      return false;
    }
}
